import React from 'react';
import { Helpbot } from './components/Helpbot';
import { HelpbotStateProvider } from './contexts/HelpbotStateProvider';
const SupportHelpbot = () => {
    return (React.createElement(HelpbotStateProvider, null,
        React.createElement(Helpbot, null)));
};
export { SupportHelpbot };
export default SupportHelpbot;
